<script lang="ts" setup>
import HeadlineListSection from '../../HeadlineListSection.vue';
import WhereToConsultCard from '../../WhereToConsult/WhereToConsultCard.vue';

defineProps<{
  imageNumber: number;
}>();
</script>

<template>
  <WhereToConsultCard title="iDeCoの活用方法" :image-number="imageNumber">
    <p>
      さまざまなメリットがある「iDeCo」の具体的な活用方法としては、主に次の2パターンが挙げられます。
    </p>
    <HeadlineListSection>
      <li><a href="#card4Step1">老後資金としての利用</a></li>
      <li><a href="#card4Step2">節税効果の活用</a></li>
    </HeadlineListSection>
    <h3 id="card4Step1">老後資金としての利用</h3>
    <p>iDeCoは、老後資金の準備に取り組むための確定拠出年金制度です。</p>
    <p>
      毎月の掛金は指定した銀行口座からの自動引き落としで拠出され、原則60歳になるまでは一切の資産を引き出せません。
    </p>
    <p>
      手元にお金が残っていると使い込んでしまう方でも、半ば強制的に老後資金の貯蓄に取り組めることが特徴です。
    </p>
    <p>
      厚生労働省の「厚生年金保険・国民年金保険の概況」によると、令和4年度における公的年金の平均受給月額は、老齢厚生年金が143,973円、老齢基礎年金が56,316円となっています。
    </p>
    <p>
      ゆとりある老後生活を送るためにも、iDeCoを積極的に活用しながら、なるべく早いうちに老後資金の準備に取り掛かりましょう。
    </p>
    <h3 id="card4Step2">節税効果の活用</h3>
    <p>
      iDeCoに拠出した掛金は全額が所得控除の対象となり、60歳以降に引き出す際も大きな所得控除が受けられます。
    </p>
    <p>
      運用中に得られた利益は非課税で再投資に回せる点も含め、iDeCoではさまざまな税制上の優遇措置が講じられています。
    </p>
    <p>
      元本確保型の商品（定期預金や保険など）を選択すれば、運用によるリターンは見込めないものの、拠出額によっては大きな節税効果が期待できます。
    </p>
    <p>
      日本の税制では「累進課税制度」が採用されており、所得が多い方ほど納税額が増える仕組みです。所得が多い方で節税対策に取り組みたい方は、積極的にiDeCoを活用されることをおすすめします。
    </p>
  </WhereToConsultCard>
</template>

<style lang="scss" module></style>
